import { render, staticRenderFns } from "./recordUpload.vue?vue&type=template&id=707d4301&scoped=true"
import script from "./recordUpload.vue?vue&type=script&lang=js"
export * from "./recordUpload.vue?vue&type=script&lang=js"
import style0 from "./recordUpload.vue?vue&type=style&index=0&id=707d4301&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707d4301",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('707d4301')) {
      api.createRecord('707d4301', component.options)
    } else {
      api.reload('707d4301', component.options)
    }
    module.hot.accept("./recordUpload.vue?vue&type=template&id=707d4301&scoped=true", function () {
      api.rerender('707d4301', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/list/components/recordUpload.vue"
export default component.exports